module.exports = __webpack_public_path__ + "static/media/startupKar.0398c455.png";